import { CartItemDescriptionEnum, CartItemDto, ProductSubTypesEnum, ProductTypesEnum } from '@bondsports/types';
import { AddOn, League, Membership, Package, PunchPass, Reservation } from '@components/atoms/icons';
import { cn } from '@utils';

// TODO: remove this, should import from @bondsports/types https://bond-sports.atlassian.net/browse/BOND-14216
// Or define metadata for league v2 products
const LEAGUE_V2_SUBTYPES = [
	ProductSubTypesEnum.LEAGUE_V2_CAPTAIN,
	ProductSubTypesEnum.LEAGUE_V2_INVITED_PLAYER,
	ProductSubTypesEnum.LEAGUE_V2_PLAYER,
	ProductSubTypesEnum.LEAGUE_V2_FREE_AGENT,
	ProductSubTypesEnum.LEAGUE_V2_ORGANIZER,
	ProductSubTypesEnum.LEAGUE_V2_COACH,
];

interface CartAvatarBoxProps {
	item: CartItemDto;
	className?: string;
}

const getIconForProductResourceType = (item: CartItemDto) => {
	if (item.metadata?.isAddon) {
		return AddOn;
	}

	if (item.metadata?.description === CartItemDescriptionEnum.PUNCH_PASS) {
		return PunchPass;
	}

	if (item.product?.productSubType && LEAGUE_V2_SUBTYPES.includes(item.product?.productSubType)) {
		return League;
	}

	const productResourceType = item.product?.productType ?? item.parentResourceType;

	switch (productResourceType) {
		case ProductTypesEnum.RESERVATION:
			return Reservation;
		case ProductTypesEnum.MEMBERSHIP:
			return Membership;
		case ProductTypesEnum.REGISTRATION:
			return Package;
		case ProductTypesEnum.GOODS:
			return Package;
		case ProductTypesEnum.PACKAGE:
			return Membership;
		default:
			return AddOn;
	}
};

export const CartAvatarBox = ({ item, className }: CartAvatarBoxProps) => {
	const Icon = getIconForProductResourceType(item);

	return (
		<div className={cn('flex h-9 w-9 items-center justify-center rounded-xl bg-[#F0F2F5] p-1.5', className)}>
			<Icon className="text-black" />
		</div>
	);
};
